// extracted by mini-css-extract-plugin
export default {"root":"SegmentedControl_root__gA8lk","segment":"SegmentedControl_segment__fMzsv","segmentActive":"SegmentedControl_segmentActive__4HaIL"};